<template>
    <div class="row align-items-top justify-content-left container-box vertical">
        <div v-for="property in properties.slice(0, item_number)" class="col-12 col-sm-6">
            <div class="item">
                <a :href="property_route.replace('slug', property.translate.slug) + params" target="_blank" class="img" :style="'background-image: url(\'/storage/' + property.images[0].path + '\');'" :alt="property.translate.name" :title="property.translate.name"></a>
                <div v-if="!property.busy" class="budget text-color-green">{{__('pages.available')}}</div>
                <div v-else class="budget text-color-red">{{__('pages.reserved')}}</div>
                <a :href="property_route.replace('slug', property.translate.slug) + params" target="_blank"><h4 class="title" :title="property.translate.name">{{property.translate.name}}</h4></a>
                <div class="address">{{property.public_address}}</div>
                <div class="phone">{{property.phone}}</div>
                <div class="price"><span>{{number_format(property.price)}}</span>{{' Ft' + __('pages.property.prices.from')}}</div>
                <hr>
                <div class="star">
                    <i class="fas fa-star"></i>
                    <span>({{ property.rate_total}}) <small>{{property.rate_count}} {{__('pages.opinion')}}</small></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['properties', 'item_number', 'property_route', 'params']
}
</script>